export const authRoutes = {
    api: {
        login: (): string => '/auth/login',
        logout: (): string => '/auth/logout',
        register: (): string => '/auth/register',
        registerVerification: (): string => '/auth/verify',
        resendOTP: (): string => '/auth/resend_verification',
        forgotPassword: (): string => '/auth/forgot_password',
        resendForgotPasswordOTP: (): string => '/auth/forgot_password/resend',
        verifyForgotPassword: (): string => '/auth/forgot_password/verify',
        resetPassword: (): string => '/auth/forgot_password/reset',
    },
    app: {
        login: (): string => '/auth/login',
        register: (): string => '/auth/register',
        registerVerification: (): string => '/auth/register_verification',
        forgotPassword: (): string => '/auth/forgot_password',
        forgotPasswordVerification: (): string => '/auth/verify_forgot_password',
        resetPassword: (): string => '/auth/reset_password',
    },
};
